import { DayPartSections } from '@griply/types';

export const getDayPartStartTime = (
  dayPart: DayPartSections,
): number | null => {
  switch (dayPart) {
    case DayPartSections.AllDay:
      return null;
    case DayPartSections.Morning:
      return 9 * 60 * 60 * 1000;
    case DayPartSections.Afternoon:
      return 12 * 60 * 60 * 1000;
    case DayPartSections.Evening:
      return 18 * 60 * 60 * 1000;
    case DayPartSections.Overdue:
      return null;
    default:
      return null;
  }
};
